import { number, object, string } from 'yup'

export type UserAccountData = {
	id: number | null
	firstName: string
	lastName: string
}

export function DefaultUserAccountData(
	id: number | null = null,
	firstName: string = '',
	lastName: string = ''
): UserAccountData {
	const userAccount: UserAccountData = { id: id, firstName: firstName, lastName: lastName }
	return userAccount
}

export function getUserAccountAutocompleteText(userAccount: UserAccountData) {
	return `${userAccount.firstName} ${userAccount.lastName}`
}

/**
 * svelecte `renderer` for user-account autocompletes. Fetched/built options carry a
 * `text` label, but a bound UserAccountData value object (e.g. the logged-in user on a
 * new form) does not — without this the selected item renders blank. Falls back to the
 * full name when `text` is absent. Shared by every user-account autocomplete consumer.
 */
export function userAccountAutocompleteRenderer(item: object): string {
	const user = item as UserAccountData & { text?: string }
	return user.text ?? getUserAccountAutocompleteText(user)
}

export function copyUserAccountData(userAccount: UserAccountData) {
	const copy: UserAccountData = DefaultUserAccountData()
	Object.assign(copy, userAccount)
	return copy
}

export const userAccountDataSchema = object({
	id: number().notRequired(),
	firstName: string().notRequired(),
	lastName: string().notRequired()
})
